import * as PIXI from 'pixi.js'

import { measureFont } from '../utils'

export default function createTexture(tokens, width, height, style = {}, resolution = 1) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  setContextSize(context, width, height, resolution)
  setContextStyle(context, style)
  drawTokensOnContext(context, tokens)

  const texture = PIXI.Texture.from(canvas, { mipmap: PIXI.MIPMAP_MODES.OFF, resolution })
  return texture
}

function drawTokensOnContext(context, tokens, font) {
  context.textBaseline = 'middle'
  const fontMetrics = measureFont(font)
  for (const token of tokens) {
    token.draw(context, fontMetrics)
  }
}

const MIN_CANVAS_SIZE = 1

function setContextSize(context, width, height, scale) {
  context.canvas.width = Math.max(width * scale, MIN_CANVAS_SIZE)
  context.canvas.height = Math.max(height * scale, MIN_CANVAS_SIZE)
  context.scale(scale, scale)
}

function setContextStyle(context, style) {
  context.font = style.font
  context.fillStyle = style.color
}
